module.exports = __webpack_public_path__ + "static/desktop-53c392cd507db65d73f61b5569042a96.jpg";